<div
  class="menubar-hoverable header-fixed menubar-pin"
  style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #ffffff;
  "
>
  <!-- header -->

  <!-- menu -->

  <div id="base">
    <div id="content" class="category-wise-main-container">
      <div (click)="collapseColumnOption()"  class="page-info-with-export-button">
        <div class="page-name-category-wise">
          <span class="report-text-category">{{ 'report' | translate  }}</span>
          <span class="report-text-category-main-page">
            {{ 'transferCertificate' | translate  }}
          </span>
        </div>
        <div class="export-button-container-category-wise">
          <button *ngIf="((tableHeaderData && tableHeaderData.length>0)&&(tableRowData && tableRowData.length>0))" (click)="exportReport()" class="btn-export-category-wise" [disabled]="isExportingReport">
            <i class="ri-download-2-line" *ngIf="!isExportingReport"></i>
            <app-button-loader *ngIf="isExportingReport"></app-button-loader>
            {{ 'export' | translate  }}
          </button>
        </div>
      </div>

      <div   class="sub-container-transfer-certificate-container">
        <div   (click)="collapseColumnOption()" class="tc-filter-container">
          <div
            [ngClass]="{
              'filter-sub-container': !isFilterExpanded,
              'filter-sub-container-open': isFilterExpanded
            }"
          >
            <div class="applied-filter-container">
              <div class="applied-filter-container-with-heading">
                <div class="filter-by-heading">
                  {{ 'filterBy' | translate  }} : 
                </div>
                <div class="applied-filters">
                  <span class="filter-name-text">
                    {{ 'wing' | translate  }} :
                  </span>
                  <span class="filter-name">
                    {{
                      appliedFilterData != null
                        ? appliedFilterData[0].wing
                        : ('all' | translate )
                    }}
                  </span>
                </div>
                <div class="applied-filters">
                  <span class="filter-name-text">
                    {{ 'class' | translate  }} :
                  </span>
                  <span class="filter-name">
                    {{
                      appliedFilterData != null
                        ? appliedFilterData[0].class
                        : ('all' | translate )
                    }}
                  </span>
                </div>
                <div class="applied-filters">
                  <span class="filter-name-text">
                    {{ 'section' | translate  }} :
                  </span>
                  <span class="filter-name">
                    {{
                      appliedFilterData != null
                        ? appliedFilterData[0].section
                        : ('all' | translate )
                    }}
                  </span>
                </div>
                <div class="applied-filters">
                  <span class="filter-name-text">
                    {{ 'caste' | translate  }} :
                  </span>
                  <span class="filter-name">
                    {{
                      appliedFilterData != null
                        ? appliedFilterData[0].caste
                        : ('all' | translate )
                    }}
                  </span>
                </div>
                <div class="applied-filters">
                  <span class="filter-name-text">
                    {{ 'gender' | translate  }} :
                  </span>
                  <span class="filter-name">
                    {{
                      appliedFilterData != null
                        ? appliedFilterData[0].gender
                        : ('all' | translate )
                    }}
                  </span>
                </div>
              </div>
              <div class="reset-filter-button">
                <div
                  *ngIf="enableReset"
                  (click)="resetFilter()"
                  class="reset-button"
                >
                  {{ 'reset' | translate  }}
                </div>
                <div *ngIf="!isFilterExpanded" class="more-filter-button">
                  <button (click)="expandFilter()" >
                    {{ 'moreFilter' | translate  }}
                  </button>
                </div>
                <div *ngIf="isFilterExpanded" class="less-filter-button">
                  <button (click)="expandFilter()" style="min-height: 40px;">
                    {{ 'lessFilter' | translate  }}
                  </button>
                </div>
              </div>
            </div>
            <div class="filter-selection-option">
              <div class="filter-selection-with-loader">
                <div class="label-with-selection">
                  <div class="label-selection">
               {{'selectWing' | translate }}
               </div>
                  <select
                  [(ngModel)]="selectedWing"
                  (change)="
                    selectedWing
                      ? getClassStandardList(selectedWing)
                      : applyAllWing()
                  "
                  class="selection-for-filter"
                  name=""
                  id=""
                >
                  <option selected [ngValue]="null">
                    {{ 'all' | translate  }}
                  </option>
                  <option *ngFor="let key of wingListData" [ngValue]="key">
                    {{ key.classCategoryName }}
                  </option>
                </select>
                
                </div>
                <span *ngIf="isLoadingWingInfo" class="loader-selection">
                  <app-button-loader
                    [borderStyle]="'3px solid var(--brand-primary-color)'"
                  ></app-button-loader>
                </span>

              </div>
              <div class="filter-selection-with-loader">
               <div class="label-with-selection">
                <div class="label-selection">
                  {{'selectClass' | translate }}
                 </div>
                <select
                  [(ngModel)]="selectedClass"
                  (change)="
                    selectedClass
                      ? getClassSectionList(selectedClass)
                      : applyAllClass()
                  "
                  class="selection-for-filter"
                  name=""
                  id=""
                >
                  <option value="" [ngValue]="null">
                    {{ 'all' | translate  }}
                  </option>
                  <option *ngFor="let key of classStandardData" [ngValue]="key">
                    {{ key.classStandardName }}
                  </option>
                </select>
               </div>
                <span *ngIf="isLoadingClassInfo" class="loader-selection">
                  <app-button-loader
                    [borderStyle]="'3px solid var(--brand-primary-color)'"
                  ></app-button-loader>
                </span>
              </div>

              <div class="filter-selection-with-loader">
                <div class="label-with-selection">
                  <div class="label-selection">
                    {{'selectSection' | translate }}
                   </div>
                  <select
                    [(ngModel)]="selectedSection"
                    class="selection-for-filter"
                    name=""
                    id=""
                  >
                    <option value="" [ngValue]="null">
                      {{ 'all' | translate  }}
                    </option>
                    <option *ngFor="let key of classSectionData" [ngValue]="key">
                      {{ key.classDivision }}
                    </option>
                  </select>
                </div>
                <span *ngIf="fetchingSectionData" class="loader-selection">
                  <app-button-loader
                    [borderStyle]="'3px solid var(--brand-primary-color)'"
                  ></app-button-loader>
                </span>
              </div>
              
              <div class="label-with-selection">
                <div class="label-selection">
                  {{'selectCaste' | translate }}
                 </div>
                <select
                  [(ngModel)]="selectedCaste"
                  class="selection-for-filter"
                  name=""
                  id=""
                >
                  <option value="" [ngValue]="null" selected>
                    {{ 'all' | translate  }}
                  </option>
                  <option *ngFor="let key of categoryData" [ngValue]="key">
                    {{ key.castCategory }}
                  </option>
                </select>
              </div>

             <div class="label-with-selection">
              <div class="label-selection">
                {{'selectGender' | translate }}
               </div>
              <select
              [(ngModel)]="selectedGender"
              class="selection-for-filter"
              name=""
              id=""
            >
              <option value="" [ngValue]="null" selected>
                {{ 'all' | translate  }}
              </option>
              <option *ngFor="let key of genderData" [ngValue]="key">
                {{ key.studentGender }}
              </option>
            </select>
             </div>
            </div>
            <div class="result-data-with-apply-button">
              <div class="result-available">
                {{ tcResultsAvailable }} {{ 'result' | translate  }}
              </div>
              <div class="apply-filter-button">
                <button
                  (click)="applyFilter()"
                  class="apply-button-filter-data"
                >
                  {{ 'apply' | translate  }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div   (click)="collapseColumnOption()" class="collected-stat-tc">
          <ng-container *ngIf="!isLoadingStatData">
            <ng-container *ngIf="tcStatInfo && tcStatInfo.length > 0">
              <div
                *ngFor="let data of tcStatInfo"
                class="stat-container-data-tc"
              >
                <div class="heading-stat">
                  {{ data.statKey }}
                </div>
                <div class="stat-data-tc">
                  {{ data.statValue }}
                </div>
              </div>
            </ng-container>
          </ng-container>
          <div *ngIf="isLoadingStatData" class="loader-stat-info">
            <app-button-loader
              [borderStyle]="'3px solid var(--brand-primary-color)'"
            ></app-button-loader>
          </div>
        </div>

        <div class="table-of-data-tc-report">
          <table class="table-data-category-wise">
            <thead class="category-wise-table-header">
              <tr>
                <ng-container
                  *ngFor="let tableData of tableHeaderData; let index = index"
                >
                  <th *ngIf="tableData.isDefault == 1">
                    <div
                      class="selected-first-row-category"
                      (click)="expandColumnOption(index)"
                    >
                      <span>{{ tableData.columnName }}</span>
                      <span
                        ><img
                          class="row-dropdown-category"
                          src="../../assets/img/row-dropdown.png"
                          alt="arrow"
                      /></span>
                    </div>
                    <div
                      class="option-for-first-row"
                      *ngIf="columnIndex === index"
                    >
                      <div
                        class="option-for-first-row-data"
                        *ngFor="let tableInfoData of tableHeaderData"
                      >
                        <span
                          ><input
                            type="checkbox"
                            (click)="
                              updateTableColumn(
                                tableData.slug,
                                tableInfoData.slug
                              )
                            "
                            id="column-name-{{ tableInfoData.slug }}"
                            [disabled]="tableInfoData.isDefault == 1"
                            [checked]="tableInfoData.isDefault == 1"
                        /></span>
                        <label
                          class="slug-labels"
                          for="column-name-{{ tableInfoData.slug }}"
                          >{{ tableInfoData.columnName }}</label
                        >
                      </div>
                    </div>
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody
              (click)="collapseColumnOption()"
              class="category-wise-table-body"
            >
              <ng-container
                *ngIf="( tableRowData && tableRowData.length > 0 )&& !isLoadingTableData"
              >
                <ng-container *ngFor="let tableInfo of tableRowData">
                  <tr>
                    <ng-container *ngFor="let tableColumns of tableHeaderData">
                      <td
                        [ngClass]="{
                          'not-submitted-status':
                            tableInfo.Status === 'Not Submitted' &&
                            tableColumns.columnName == 'Status',
                          'submitted-status':
                            tableInfo.Status === 'Submitted' &&
                            tableColumns.columnName == 'Status'
                        }"
                        *ngIf="tableColumns.isDefault === 1"
                      >
                        {{ tableInfo[tableColumns.columnName] }}
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>

              <div
                *ngIf="!isLoadingTableData &&(tableRowData && tableRowData.length == 0)
                "
                class="no-data-available"
              >
                {{ 'noData' | translate  }}
              </div>

              <div *ngIf="isLoadingTableData" class="loader-stat-info">
                <app-button-loader
                  [borderStyle]="'3px solid var(--brand-primary-color)'"
                ></app-button-loader>
              </div>
            </tbody>
          </table>
        </div>

        <div   (click)="collapseColumnOption()" class="pagination-and-page-selector">
          <div class="page-selection-container">
            <div class="show-result">{{ 'show' | translate  }}</div>
            <select
              (change)="changePageLimitData($event.target.value)"
              class="selection-page-number"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="60">60</option>
              <option value="70">70</option>
            </select>
          </div>
          <div class="page-switcher-category-wise">
            <div
              (click)="changePage(startingPageNumber - 1)"
              *ngIf="startingPageNumber > 1"
              class="arrow-left-page-switcher"
            >
              <i class="ri-arrow-left-s-line"></i>
            </div>
            <ng-container *ngIf="pageNumbers && pageNumbers.length > 0">
              <div
                *ngFor="let pageNumberInfo of pageNumbers"
                (click)="switchPageNumber(pageNumberInfo)"
                class="number-page-switcher"
                [ngClass]="{
                  'selected-page-switcher':
                    pageNumberInfo === startingPageNumber,
                  'selected-disabled-page-switcher': pageNumberInfo === '...'
                }"
              >
                {{ pageNumberInfo }}
              </div>
            </ng-container>

            <div
              (click)="changePage(startingPageNumber + 1)"
              *ngIf="startingPageNumber != maxPageNumber"
              class="arrow-left-page-switcher"
            >
              <i class="ri-arrow-right-s-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
